import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["initialFocus", "containers", "features"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import L, { useEffect as U, useRef as d } from "react";
import { forwardRefWithAs as N, render as w } from '../../utils/render.js';
import { useServerHandoffComplete as I } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as x } from '../../hooks/use-sync-refs.js';
import { Features as g, Hidden as k } from '../../internal/hidden.js';
import { focusElement as f, focusIn as M, Focus as p, FocusResult as G } from '../../utils/focus-management.js';
import { match as A } from '../../utils/match.js';
import { useEvent as C } from '../../hooks/use-event.js';
import { useTabDirection as K, Direction as b } from '../../hooks/use-tab-direction.js';
import { useIsMounted as O } from '../../hooks/use-is-mounted.js';
import { useOwnerDocument as W } from '../../hooks/use-owner.js';
import { useEventListener as V } from '../../hooks/use-event-listener.js';
import { microTask as F } from '../../utils/micro-task.js';
import { useWatch as y } from '../../hooks/use-watch.js';
import { useDisposables as q } from '../../hooks/use-disposables.js';

function P(t) {
  if (!t) return new Set();
  if (typeof t == "function") return new Set(t());
  var n = new Set();

  var _iterator = _createForOfIteratorHelper(t.current),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      e.current instanceof HTMLElement && n.add(e.current);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
}

var J = "div";

var h = function (r) {
  return r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r;
}(h || {});

function X(t, n) {
  var e = d(null),
      o = x(e, n),
      u = t.initialFocus,
      i = t.containers,
      _t$features = t.features,
      r = _t$features === void 0 ? 30 : _t$features,
      l = _objectWithoutProperties(t, _excluded);

  I() || (r = 1);
  var m = W(e);
  Q({
    ownerDocument: m
  }, Boolean(r & 16));
  var c = Y({
    ownerDocument: m,
    container: e,
    initialFocus: u
  }, Boolean(r & 2));
  Z({
    ownerDocument: m,
    container: e,
    containers: i,
    previousActiveElement: c
  }, Boolean(r & 8));

  var v = K(),
      R = C(function (s) {
    var T = e.current;
    if (!T) return;

    (function (B) {
      return B();
    })(function () {
      var _A;

      A(v.current, (_A = {}, _defineProperty(_A, b.Forwards, function () {
        M(T, p.First, {
          skipElements: [s.relatedTarget]
        });
      }), _defineProperty(_A, b.Backwards, function () {
        M(T, p.Last, {
          skipElements: [s.relatedTarget]
        });
      }), _A));
    });
  }),
      _ = q(),
      H = d(!1),
      j = {
    ref: o,
    onKeyDown: function onKeyDown(s) {
      s.key == "Tab" && (H.current = !0, _.requestAnimationFrame(function () {
        H.current = !1;
      }));
    },
    onBlur: function onBlur(s) {
      var _A2;

      var T = P(i);
      e.current instanceof HTMLElement && T.add(e.current);
      var E = s.relatedTarget;
      E instanceof HTMLElement && E.dataset.headlessuiFocusGuard !== "true" && (S(T, E) || (H.current ? M(e.current, A(v.current, (_A2 = {}, _defineProperty(_A2, b.Forwards, function () {
        return p.Next;
      }), _defineProperty(_A2, b.Backwards, function () {
        return p.Previous;
      }), _A2)) | p.WrapAround, {
        relativeTo: s.target
      }) : s.target instanceof HTMLElement && f(s.target)));
    }
  };

  return L.createElement(L.Fragment, null, Boolean(r & 4) && L.createElement(k, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: g.Focusable
  }), w({
    ourProps: j,
    theirProps: l,
    defaultTag: J,
    name: "FocusTrap"
  }), Boolean(r & 4) && L.createElement(k, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: g.Focusable
  }));
}

var z = N(X),
    ye = Object.assign(z, {
  features: h
}),
    a = [];

if (typeof window != "undefined" && typeof document != "undefined") {
  var t = function t(n) {
    n.target instanceof HTMLElement && n.target !== document.body && a[0] !== n.target && (a.unshift(n.target), a = a.filter(function (e) {
      return e != null && e.isConnected;
    }), a.splice(10));
  };

  var handle = t;
  window.addEventListener("click", t, {
    capture: !0
  }), window.addEventListener("mousedown", t, {
    capture: !0
  }), window.addEventListener("focus", t, {
    capture: !0
  }), document.body.addEventListener("click", t, {
    capture: !0
  }), document.body.addEventListener("mousedown", t, {
    capture: !0
  }), document.body.addEventListener("focus", t, {
    capture: !0
  });
}

function D() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
  var n = d(a.slice());
  return y(function (_ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 1),
        e = _ref3[0];

    var _ref4 = _slicedToArray(_ref2, 1),
        o = _ref4[0];

    o === !0 && e === !1 && F(function () {
      n.current.splice(0);
    }), o === !1 && e === !0 && (n.current = a.slice());
  }, [t, a, n]), C(function () {
    var e;
    return (e = n.current.find(function (o) {
      return o != null && o.isConnected;
    })) != null ? e : null;
  });
}

function Q(_ref5, n) {
  var t = _ref5.ownerDocument;
  var e = D(n);
  y(function () {
    n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && f(e());
  }, [n]);
  var o = d(!1);
  U(function () {
    return o.current = !1, function () {
      o.current = !0, F(function () {
        o.current && f(e());
      });
    };
  }, []);
}

function Y(_ref6, o) {
  var t = _ref6.ownerDocument,
      n = _ref6.container,
      e = _ref6.initialFocus;
  var u = d(null),
      i = O();
  return y(function () {
    if (!o) return;
    var r = n.current;
    r && F(function () {
      if (!i.current) return;
      var l = t == null ? void 0 : t.activeElement;

      if (e != null && e.current) {
        if ((e == null ? void 0 : e.current) === l) {
          u.current = l;
          return;
        }
      } else if (r.contains(l)) {
        u.current = l;
        return;
      }

      e != null && e.current ? f(e.current) : M(r, p.First) === G.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
    });
  }, [o]), u;
}

function Z(_ref7, u) {
  var t = _ref7.ownerDocument,
      n = _ref7.container,
      e = _ref7.containers,
      o = _ref7.previousActiveElement;
  var i = O();
  V(t == null ? void 0 : t.defaultView, "focus", function (r) {
    if (!u || !i.current) return;
    var l = P(e);
    n.current instanceof HTMLElement && l.add(n.current);
    var m = o.current;
    if (!m) return;
    var c = r.target;
    c && c instanceof HTMLElement ? S(l, c) ? (o.current = c, f(c)) : (r.preventDefault(), r.stopPropagation(), f(m)) : f(o.current);
  }, !0);
}

function S(t, n) {
  var _iterator2 = _createForOfIteratorHelper(t),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var e = _step2.value;
      if (e.contains(n)) return !0;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return !1;
}

export { ye as FocusTrap };